import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "discussion-item" }
const _hoisted_2 = { class: "discussion-item__title-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "discussion-item__icon-wrapper thread-comment__icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "discussion-item__avatar-icon iconfont iprofile-icon" })
], -1)
const _hoisted_4 = { class: "discussion-item__title-right thread-comment__name" }
const _hoisted_5 = { class: "thread-comment__username" }
const _hoisted_6 = { class: "thread-comment__time" }
const _hoisted_7 = { class: "discussion-item__title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "discussion-item__flex-box" }
const _hoisted_10 = { class: "discussion-item__left-box" }
const _hoisted_11 = { class: "discussion-item__left" }
const _hoisted_12 = {
  key: 0,
  class: "discussion-item__icon-link"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "discussion-item__icon-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "discussion-item__icon iconfont ibubble" })
], -1)
const _hoisted_14 = {
  key: 0,
  class: "discussion-item__left-text"
}
const _hoisted_15 = {
  key: 1,
  class: "discussion-item__left-text"
}
const _hoisted_16 = { class: "discussion-item__right-box" }
const _hoisted_17 = { class: "discussion-item__update discussion__hide-m" }
const _hoisted_18 = { class: "discussion-item__update discussion__show-m" }

import { ThreadView } from '@/models/forum'
import { DocView } from '@/models/doc'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreadListItem',
  props: {
    thread: null,
    doc: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.thread.author.username), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(__props.thread.posted_time), 1)
        ]),
        _createElementVNode("h3", _hoisted_7, [
          (__props.doc.isCommunityEOC)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.thread.title), 1))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {
              name: __props.doc.routeNames().thread,
              params: { thread: __props.thread.url_slug },
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.thread.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (__props.thread.comments_count !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                (__props.thread.comments_count === 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(__props.thread.comments_count) + " comment ", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(__props.thread.comments_count) + " comments ", 1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", _hoisted_17, " Updated " + _toDisplayString(__props.thread.last_active_time), 1),
        _createElementVNode("p", _hoisted_18, _toDisplayString(__props.thread.last_active_time), 1)
      ])
    ])
  ]))
}
}

})